export const CREATORS_CONST = {
    TESTIMONIALS: 'Testimonials',
    FREQUENTLY_ASKED_QUESTIONS: 'Frequently Asked Questions',
    APPLY_TO_JOIN: 'Apply for New Creator Account',
    BOOK_A_DEMO: 'BOOK A DEMO',
    MONETIZE_PLATFORM_MSG: 'Stop Renting Your Audience.<br>Own Your Platform. Build Your Empire.',
    BECOME_A_CREATOR: 'BECOME A CREATOR',
    CREATE_ON_TOPFANS: 'Creators',
    BOOK_DEMO: 'Book Demo',
    FEATURE_LIST: 'Feature List',
    CREATORS: 'CREATORS',
    APPLY_NOW: 'APPLY NOW',
    WATCH_DEMO_VIDEO: 'watch_demo_video',
    WATCH_A_DEMO: 'WATCH A DEMO',
    APPLY_NOW_PATH: 'apply_now',
    SUBMITTED_FORM: 'submitted_form',
    WATCH_SIZZLE_VIDEO: 'watch_sizzle_video',
    CONTACT_US: 'CONTACT US',
    REQUEST_DEMO: 'REQUEST DEMO',
    APPLY: 'APPLY',
    REFERRAL_QUERY_PARAM: 'key',
}

export const MARKETING_FAQ_THEME_VARIABLES = {
    '--configSecondaryBgColor': '#FFEBFF',
    '--configPostTextColor': '#000000',
} as const;

export const CREATORS_VIDEOS_SRC = 'https://cdn-www7.topfan.dev/Posts/StreamedPostVideo/Posts/PostVideo/montage-creators-page/montage-creators-page.m3u8';

export const CREATORS_VIEDOS_MODAL_SRC = 'https://cdn-www.topfans.com/static/TopFan.mov';

export const DEMO_VIDEO_SRC = {
    poster: 'https://cdn-www.topfans.com/TopFans/Home/1761723115_preview_demo_video.webp',
    video: 'https://cdn-www.topfans.com/Posts/StreamedPostVideo/Posts/PostVideo/topfans_demo_video/topfans_demo_video.m3u8',
    sizzle_poster: 'https://cdn-www.topfans.com/TopFans/Home/1761723282_sizzle_video.webp'   
}

export const VIDEO_OPTIONS = {
    sources: [
        {
            src: CREATORS_VIDEOS_SRC,
            type: 'application/x-mpegURL'
        }
    ],
    autoplay: true,
    loop: true,
    playsinline: true,
    muted: true,
    preload: 'auto',
    controls: false,
    controlBar: {
        playToggle: false,
        muteToggle: false,
        fullscreenToggle: false,
        volumePanel: false,
        remainingTimeDisplay: false,
        currentTimeDisplay: false,
        timeDivider: false,
        progressControl: false,
        seekBar: false,
        durationDisplay: false
    },
    loadingSpinner: false,
    bigPlayButton: false
}

export const TESTIMONIALS_DATA = [
    {
        name: 'Tulsa Bite',
        user_name: 'tulsa_bite',
        creator_type: 'Creator and Influencer',
        content:
            'When I entered the scene in 2022, I saw a gap in creator tools and frameworks designed to help them thrive. Now with TopFan, I’m giving back by sharing my journey and equipping others with the insights they need to navigate the industry with confidence. I’m excited to create a home for my audience, where I can offer new items in my store, like 1:1 calls for creators seeking guidance on brand collaborations, exclusive merch, and subscriptions—all designed to foster growth, connection, and creativity in the food space.',
        profileImage: 'https://topfanlite-prod-s3-backend.s3.amazonaws.com/profile_image/profile_1745419226639_img_6677.jpeg'
    },
    {
        name: 'The Predictors',
        user_name: 'the-predictors',
        creator_type: 'Organizations',
        content:
            'ThePredictors provides real-time analytics on player performance, injuries, and other factors. Our proprietary Banged Up Score (BUS) system evaluates the overall health of teams to predict future performance! We’re using TopFan to build a new experience for our audience where we offer subscriptions to exclusive content for subscribers.',
        profileImage: 'https://topfanlite-prod-s3-backend.s3.amazonaws.com/profile_image/profile_1747837446239_screenshot_2025-05-21_at_10.23.26 am.png'
    },
    {
        name: 'David Gold',
        user_name: 'davidgold',
        creator_type: 'Professionals',
        content:
            'I hold a PhD in Atmospheric Sciences, I’m a certified consulting meteorologist and I’ve been in the weather industry for over 18 years… this space is where I’ll bring all that experience directly to you in the form of subscription based content and experiences.',
        profileImage: 'https://topfanlite-prod-s3-backend.s3.amazonaws.com/profile_image/profile_1742078010105_weather_kingdom_logo_v3.jpg'
    },
    {
        name: 'John Ward',
        user_name: 'johnward',
        creator_type: 'Food, Fitness and Wellness',
        content:
            "I’ve been in the industry for a long time now, from decades in soccer to my transition to health and fitness nearly 10 years ago, but its impact on my life is far more important than the time I’ve spent in it. It's afforded me incredible opportunities coast-to-coast and brought amazing people into my life—but more importantly, it's played a massive role in my mental health. One of the biggest factors for me in pursuing this career and having a passion for it is my own personal experience with the mental health benefits, and wanting to provide that to others with TopFan.",
        profileImage: "https://topfanlite-prod-s3-backend.s3.amazonaws.com/profile_image/profile_1745871580146_jw_fitness_hs_'25_update_square.jpg"
    },
    {
        name: 'Katrina Darling Friedman',
        user_name: 'katrinadarlingfriedman',
        creator_type: 'Food, Fitness and Wellness',
        content:
            "After being let down by doctor after doctor who couldn't give me answers to my medical issues, and wouldn't listen to my concerns, I decided to seek out answers on my own. I discovered functional medicine and dove headfirst into learning everything I could in an effort to heal myself. Taking a root-cause, whole-body approach really changed the game for me. Over time, I was successfully able to heal myself naturally from all of the things doctors told me I never would. The acne, anxiety, gut issues, fatigue, heavy periods, indigestion, bloating, insomnia, and feeling cold all the time. And then I made it my mission to help others do the same. With TopFan I can offer subscriptions to my services like pantry clean-outs, 1:1 experiences and custom meal plans.",
        profileImage: 'https://topfanlite-prod-s3-backend.s3.amazonaws.com/profile_image/profile_1744683831269_katrina_previews_kmitiska_photography-7.jpg'
    },
    {
        name: 'Julia, Julia',
        user_name: 'julia-kugel',
        creator_type: 'Musicians',
        content:
            "I want to explore new ways to connect with people while maintaining control of what I create and share. Feels like TopFan is a supportive place to do just that!",
        profileImage: 'https://topfanlite-prod-s3-backend.s3.amazonaws.com/profile_image/profile_1746740888722_22_03_28_juliajulia_losangeles_robinlaananen_0694fs_copy.jpg'
    },
    {
        name: 'Mark Schlereth',
        user_name: 'markschlereth',
        creator_type: 'Athletes',
        content:
            "I'm excited to be on TopFan because even after all my travels and experiences, I still find it fascinating what I don't know about the game and life. The stuff i'm learning on a consistent basis is what I want to share with you all on this platform.",
        profileImage: 'https://topfanlite-prod-s3-backend.s3.amazonaws.com/profile_image/profile_1741886102140_screenshot_2025-03-13_at_10.14.51 am.png'
    }
]

export const EXPERIENCE_DATA = [
    {
        img: 'https://cdn-www.topfans.com/TopFans/1768477013_banner-creator-home.png',
        title: 'All-in-One Monetization',
        desc: 'No more scattered link-in-bio links, lost fans, or fragmented data. Everything you create and sell is in one place via subscription or individual purchase on your own platform: <br><br> •&nbsp;Video Libraries •&nbsp;Music Albums •&nbsp;Podcasts •&nbsp;Photos <br> •&nbsp;Courses •&nbsp;Newsletters •&nbsp;Livestreams •&nbsp;Merchandise <br> •&nbsp;Personalized Fan Experiences •&nbsp;Paid DMs •&nbsp;Tips <br> •&nbsp;Downloadables •&nbsp;Books •&nbsp;Artwork •&nbsp;Fundraisers •&nbsp;NFTs'
    },
    {
        img: 'https://cdn-www.topfans.com/TopFans/1751461154889_poster_4.webp',
        title: 'Data Continuity & Ownership',
        desc: "Unify all of your fan data in one place with Fan Relationship Management® technology. Powerful audience segmentation with consolidated demographic, purchasing and engagement data that you own. Build geo-fenced and targeted SMS text, app push notification, direct message, and email campaigns to grow deeper fan relationships and monetization."
    },
    {
        img: 'https://cdn-www.topfans.com/TopFans/1751461155221_poster_3.webp',
        title: 'Your Platform. Your Brand.',
        desc: 'Your custom Direct-to-Fan platform is made available through your own white-label mobile and desktop website on your own personalized domain name (creatorname.com). Creators also receive a custom branded, white-label iOS & Android mobile app that can receive geo-fenced push notifications.  Eliminate platform dependency and build long term equity and future liquidity for yourself.'
    },
    {
        img: 'https://cdn-www.topfans.com/TopFans/1751461155055_poster_2.png',
        title: 'AI-Driven Fan Discovery',
        desc: 'Most social and paywall platforms reward the already popular Creators, making it difficult for emerging Creators to grow their audiences. TopFan changes that. TopFan’s unique AI-driven discovery helps Creators quickly gain loyal followers and organically acquire new paying fans.'
    },
    {
        img: "https://cdn-www.topfans.com/TopFans/1751461154961_poster_1.webp",
        title: 'Dedication to Creator Success',
        desc: 'TopFan is 100% free for Creators and our transparent revenue share model (5-15%) means we only make money when the Creator makes money. Our Creator Success Team is committed to working hands-on with each Creator to develop and execute custom revenue roadmaps.'    
    }
]